function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M18.3,0l-1.4,1.4l1.8,2h-4c-0.3,0-0.6,0.1-0.8,0.4L5,14.6H0v2h5.5c0.3,0,0.6-0.1,0.8-0.4l8.9-10.8h3.6l-1.8,2l1.4,1.4 l3.4-3.7c0.4-0.4,0.4-1,0-1.4L18.3,0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,9.2l1.5-1.3L6.2,3.7C6,3.5,5.8,3.4,5.5,3.4H0v2h5L8,9.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3,11.2l-1.4,1.4l1.8,2h-3.6l-3-3.7l-1.5,1.3l3.3,4.1c0.2,0.2,0.5,0.4,0.8,0.4h4l-1.8,2l1.4,1.4l3.4-3.7 c0.4-0.4,0.4-1,0-1.4L18.3,11.2z"
}));

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 20",
    style: {
      enableBackground: "new 0 0 22 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.80e82452.svg";
export { ForwardRef as ReactComponent };